import { gql } from "@apollo/client"

export const GET_ALL_TERMINALS = gql`
  query getAllTerminals($orgIds: [ID], $search: String, $first: Int, $skip: Int, $orderBy: String) {
    allTerminals(orgIds: $orgIds, search: $search, first: $first, skip: $skip, orderBy: $orderBy) {
      totalCount
      edges {
        id
        terminalType
        nickname
        modem
        modemSn
        warrantyEndDate
        canEditName
        imageUrl
        serialNumber
        superAdminPassword
        groups {
          id
          name
          isAdminGroup
          organization {
            id
          }
        }
        organization {
          id
          name
        }
        apiTerminal {
          id
          apiId
          name
          latestDataPlan {
            ... on SingleDataPlanType {
              id
              name
              apiPlanId
              totalDataUsage
              volumeTotalAggregated
              volumeTopupAggregated
              volumeAllowedAggregated
              status
              end
              start
            }
            ... on SharedDataPlanType {
              id
              name
              apiPlanId
              totalDataUsage
              volumeTotalAggregated
              volumeTopupAggregated
              volumeAllowedAggregated
              status
              end
              start
            }
          }
        }
      }
    }
  }
`
